(function () {
    'use strict';

    angular
        .module('NaviaqWebApp')
        .factory('anonymousReportService', anonymousReportService);

    anonymousReportService.$inject = [
        '$q',
        '$http',
        'serviceUrls'
    ];

    function anonymousReportService(
        $q,
        $http,
        serviceUrls,
    ) {
        const anonymousReportApiUrl = `${serviceUrls.webApiBaseUrl}/anonymousReport`;
        const ordersBaseApiUrl = `${serviceUrls.webApiBaseUrl}/order`;

        return {
            getOrderReportContent,
            downloadOrderRelatedVideo,
            moveFileFromArchivedToHotAccessTier,
            getArrivalReportContent,
            getOrderConfirmationContent,
            getOperationLogReportContent,
            getFinalReportContent,
            getMooringReportContent,
            getDelicingReportContent,
            getOrderWorkReportContent,
            getOrderReportContentForExternalUser,
            getFinalReportContentByExternalToken,
            getArrivalReportContentByExternalToken,
            getOperationLogReportContentByExternalToken,
            getMooringReportContentByExternalToken,
            getOrderConfirmationContentByExternalToken,
            getOrderWorkReportContentByExternalToken,
            downloadOrderRelatedVideoByExternalToken,
            getDelicingReportContentByExternalToken
        };

        function getOrderReportContent(orderId) {
            const deferred = $q.defer();

            $http
                .get(`${anonymousReportApiUrl}/orderReportContent?orderId=${orderId}`)
                .then(response => deferred.resolve(response.data))
                .catch(error => deferred.reject(error));

            return deferred.promise;
        }

        function downloadOrderRelatedVideo(video) {
            const deferred = $q.defer();
            const requestUrl = `${ordersBaseApiUrl}/fileDownloadLink`;

            $http
                .post(requestUrl, video)
                .then((response) => deferred.resolve(response.data))
                .catch((error) => deferred.reject(error));

            return deferred.promise;
        }

        function downloadOrderRelatedVideoByExternalToken(externalToken, authToken, video) {
            const deferred = $q.defer();
            const requestUrl = `${anonymousReportApiUrl}/fileDownloadLinkByExternalToken?ExternalToken=${externalToken}`;
            const headers = getExternalAuthConfig(authToken);

            $http
                //.headers(headers)
                .post(requestUrl, video, headers)
                .then((response) => deferred.resolve(response.data))
                .catch((error) => deferred.reject(error));

            return deferred.promise;
        }

        function moveFileFromArchivedToHotAccessTier(orderId, video) {
            const deferred = $q.defer();
            const requestUrl = `${ordersBaseApiUrl}/moveFileFromArchivedToHotAccessTier/${orderId}`;
            $http
                .post(requestUrl, video)
                .then((response) => deferred.resolve(response.data))
                .catch((error) => deferred.reject(error));

            return deferred.promise;
        }

        function getArrivalReportContent(orderId, reportId) {
            const deferred = $q.defer();

            $http
                .get(`${anonymousReportApiUrl}/arrivalReportContent?orderId=${orderId}&reportId=${reportId}`)
                .then(response => deferred.resolve(response.data))
                .catch(error => deferred.reject(error));

            return deferred.promise;
        }

        function getArrivalReportContentByExternalToken(externalToken, reportId, authToken) {
            const deferred = $q.defer();

            $http
                .get(`${anonymousReportApiUrl}/arrivalReportContentByExternalToken?externalToken=${externalToken}&reportId=${reportId}`, getExternalAuthConfig(authToken))
                .then(response => deferred.resolve(response.data))
                .catch(error => deferred.reject(error));

            return deferred.promise;
        }

        function getOrderConfirmationContent(orderId) {
            const deferred = $q.defer();

            $http
                .get(`${anonymousReportApiUrl}/orderConfirmationContent?orderId=${orderId}`)
                .then(response => deferred.resolve(response.data))
                .catch(error => deferred.reject(error));

            return deferred.promise;
        }

        function getOrderConfirmationContentByExternalToken(externalToken, authToken) {
            const deferred = $q.defer();

            $http
                .get(`${anonymousReportApiUrl}/orderConfirmationContentByExternalToken?externalToken=${externalToken}`, getExternalAuthConfig(authToken))
                .then(response => deferred.resolve(response.data))
                .catch(error => deferred.reject(error));

            return deferred.promise;
        }

        function getOperationLogReportContent(orderId, contractorId) {
            const deferred = $q.defer();

            $http
                .get(`${anonymousReportApiUrl}/operationLogReportContent?orderId=${orderId}&contractorId=${contractorId}`)
                .then(response => deferred.resolve(response.data))
                .catch(error => deferred.reject(error));

            return deferred.promise;
        }

        function getOperationLogReportContentByExternalToken(externalToken, authToken) {
            const deferred = $q.defer();

            $http
                .get(`${anonymousReportApiUrl}/operationLogReportContentByExternalToken?externalToken=${externalToken}`, getExternalAuthConfig(authToken))
                .then(response => deferred.resolve(response.data))
                .catch(error => deferred.reject(error));

            return deferred.promise;
        }

        function getFinalReportContent(orderId) {
            const deferred = $q.defer();

            $http
                .get(`${anonymousReportApiUrl}/finalReportContent?orderId=${orderId}`)
                .then(response => deferred.resolve(response.data))
                .catch(error => deferred.reject(error));

            return deferred.promise;
        }

        function getFinalReportContentByExternalToken(externalToken, authToken) {
            const deferred = $q.defer();

            $http
                .get(`${anonymousReportApiUrl}/finalReportContentByExternalToken?externalToken=${externalToken}`, getExternalAuthConfig(authToken))
                .then(response => deferred.resolve(response.data))
                .catch(error => deferred.reject(error));

            return deferred.promise;
        }

        function getMooringReportContent(orderId) {
            const deferred = $q.defer();

            $http
                .get(`${anonymousReportApiUrl}/mooringReportContent?orderId=${orderId}`)
                .then(response => deferred.resolve(response.data))
                .catch(error => deferred.reject(error));

            return deferred.promise;
        }

        function getMooringReportContentByExternalToken(externalToken, authToken) {
            const deferred = $q.defer();

            $http
                .get(`${anonymousReportApiUrl}/mooringReportContentByExternalToken?externalToken=${externalToken}`, getExternalAuthConfig(authToken))
                .then(response => deferred.resolve(response.data))
                .catch(error => deferred.reject(error));

            return deferred.promise;
        }

        function getDelicingReportContent(orderId, reportType) {
            const deferred = $q.defer();

            $http
                .get(`${anonymousReportApiUrl}/delicingReportContent?orderId=${orderId}&reportType=${reportType}`)
                .then(response => deferred.resolve(response.data))
                .catch(error => deferred.reject(error));

            return deferred.promise;
        }

        function getDelicingReportContentByExternalToken(externalToken, authToken, reportType) {
            const deferred = $q.defer();

            $http
                .get(`${anonymousReportApiUrl}/delicingReportContentByExternalToken?externalToken=${externalToken}&reportType=${reportType}`, getExternalAuthConfig(authToken))
                .then(response => deferred.resolve(response.data))
                .catch(error => deferred.reject(error));

            return deferred.promise;
        }

        function getOrderWorkReportContent(contractorId, orderId) {
            const deferred = $q.defer();

            $http
                .get(`${anonymousReportApiUrl}/orderWorkReportContent?orderId=${orderId}&contractorId=${contractorId}`)
                .then(response => deferred.resolve(response.data))
                .catch(error => deferred.reject(error));

            return deferred.promise;
        }

        function getOrderWorkReportContentByExternalToken(externalToken, authToken) {
            const deferred = $q.defer();

            $http
                .get(`${anonymousReportApiUrl}/orderWorkReportContentByExternalToken?externalToken=${externalToken}`, getExternalAuthConfig(authToken))
                .then(response => deferred.resolve(response.data))
                .catch(error => deferred.reject(error));

            return deferred.promise;
        }

        function getOrderReportContentForExternalUser(externalToken, authToken) {
            const deferred = $q.defer();

            $http
                .get(`${anonymousReportApiUrl}/orderReportContentByExternalToken?ExternalToken=${externalToken}`, getExternalAuthConfig(authToken))
                .then(response => deferred.resolve(
                    response.data
                ))
                .catch(error => deferred.reject(error));

            return deferred.promise;
        }

        function getExternalAuthConfig(authToken) {
            var config = {
                headers: {
                    'accept': 'application/json',
                    'ExternalAuth': authToken,
                    'content-type': 'application/json'
                }
            };

            return config;
        }
    }
})();
